/// <reference types="google.maps" />

export const getLatLng = (
  address: string,
  enrollmentLocations: Record<string, any>
): Promise<{ location: google.maps.LatLng | google.maps.LatLngLiteral }> =>
  new Promise((resolve, reject) => {
    const upperAddress = address.toUpperCase()

    const location = Object.values(enrollmentLocations).find(
      (loc) => loc.uid.toUpperCase() === upperAddress
    )
    if (location) {
      const coordinates = {
        lat: location.latitude,
        lng: location.longitude,
      }
      resolve(coordinates as any)
      return
    }

    if (window.google) {
      const geocoder = new window.google.maps.Geocoder()
      geocoder.geocode(
        {
          address,
        },
        (results, status) => {
          if (status === 'OK' && results) {
            const { location } = results[0].geometry
            const coordinates = {
              lat: location.lat(),
              lng: location.lng(),
            }
            resolve(coordinates as any)
          } else {
            reject(
              'Geocode was not successful for the following reason: ' + status
            ) // eslint-disable-line prefer-promise-reject-errors
          }
        }
      )
    }
  })
